import { render, staticRenderFns } from "./VictimArmedConflict.vue?vue&type=template&id=1f230cb2"
import script from "./VictimArmedConflict.vue?vue&type=script&lang=js"
export * from "./VictimArmedConflict.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports